import { z } from 'zod';

import { BorderColor, OverlayDirection } from '../models';
import { BasePType } from './base';
import { InlineImage } from './inline-image';

export const DualOverlainImage = BasePType.extend({
  type: z.enum(['dualOverlainImage']),
  overlayBorderColor: z.nullable(BorderColor).optional(),
  overlayBorderWidth: z.string(),
  overlayDirection: z.optional(OverlayDirection),
  overlayHorizPosition: z.string(),
  overlayVertPosition: z.string(),
  baseImage: z.array(InlineImage),
  overlayImage: z.array(InlineImage),
  behaviorSettings: z.any(),
});

export type DualOverlainImage = z.infer<typeof DualOverlainImage>;
